import * as React from 'react';
import { connect } from 'react-redux';
import {
  SettingTabPanelList,
  SettingTabPanelListRow,
  SettingTabPanelListRowImageTitle,
} from '../common/SettingTabPanelList';
import ToolIconRadioButtonSet from '../common/ToolIconRadioButtonSet';
import { Dispatch, Action } from 'redux';
import { AppStates } from '../../reducers/app';
import { FontType, ShapeKind } from '../../drawing/types';
import TextboxUIAction from '../../actions/ui/TextboxUIAction';
import { TextboxState } from '../../reducers/ui/textbox';
import { Color } from '../../types/color';
import TextboxFontSizeSlider from './TextboxFontSizeSlider';
import TextboxLineHeightSlider from './TextboxLineHeightSlider';
import TextboxPaddingSlider from './TextboxPaddingSlider';
import SelectableColorIconButton from '../common/SelectableIconButton/SelectableColorIconButton';
import SelectableRectangleIconButton
from '../common/SelectableIconButton/SelectableRectangleIconButton';

interface TextboxSettingPanelProps extends TextboxState {
  readonly dispatch: Dispatch<Action>;
}

const largeButtonContainerStyle: React.CSSProperties = {
  width: '86px',
  height: '52px',
  marginLeft: '10px',
  marginRight: '10px',
};

const borderStyle: React.CSSProperties = {
  width: '100%',
  height: 2,
  backgroundColor: '#bebebe',
  border: 0,
  margin: 0,
};

const TextboxSettingPanel: React.SFC<TextboxSettingPanelProps> = React.memo((props) => {
  const { selected, toolSettings, dispatch } = props;

  return (
    <SettingTabPanelList>
      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle imgName="text_txtbox_color" />
        <ToolIconRadioButtonSet style={{ width: '460px' }}>
          <SelectableColorIconButton
            title="赤"
            imagePath="images/setting-popup/color/btn_color_red_01"
            active={toolSettings[selected].fillColor === Color.Red}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.Red, dispatch);
            }} />
          <SelectableColorIconButton
            title="青"
            imagePath="images/setting-popup/color/btn_color_blue_01"
            active={toolSettings[selected].fillColor === Color.Blue}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.Blue, dispatch);
            }} />
          <SelectableColorIconButton
            title="黄色"
            imagePath="images/setting-popup/color/btn_color_yellow_01"
            active={toolSettings[selected].fillColor === Color.Yellow}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.Yellow, dispatch);
            }} />
          <SelectableColorIconButton
            title="緑"
            imagePath="images/setting-popup/color/btn_color_green_01"
            active={toolSettings[selected].fillColor === Color.Green}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.Green, dispatch);
            }} />
          <SelectableColorIconButton
            title="黒"
            imagePath="images/setting-popup/color/btn_color_black_01"
            active={toolSettings[selected].fillColor === Color.Black}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.Black, dispatch);
            }} />
          <SelectableColorIconButton
            title="白"
            imagePath="images/setting-popup/color/btn_color_white_01"
            active={toolSettings[selected].fillColor === Color.White}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.White, dispatch);
            }} />
          <SelectableColorIconButton
            title="透明"
            imagePath="images/setting-popup/color/btn_color_none"
            active={toolSettings[selected].fillColor === Color.Transparent}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.Transparent, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_赤"
            imagePath="images/setting-popup/color/btn_color_red_02"
            active={toolSettings[selected].fillColor === Color.RedTransparent}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.RedTransparent, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_青"
            imagePath="images/setting-popup/color/btn_color_blue_02"
            active={toolSettings[selected].fillColor === Color.BlueTransparent}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.BlueTransparent, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_黄色"
            imagePath="images/setting-popup/color/btn_color_yellow_02"
            active={toolSettings[selected].fillColor === Color.YellowTransparent}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.YellowTransparent, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_緑"
            imagePath="images/setting-popup/color/btn_color_green_02"
            active={toolSettings[selected].fillColor === Color.GreenTransparent}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.GreenTransparent, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_黒"
            imagePath="images/setting-popup/color/btn_color_black_02"
            active={toolSettings[selected].fillColor === Color.BlackTransparent}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.BlackTransparent, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_白"
            imagePath="images/setting-popup/color/btn_color_white_02"
            active={toolSettings[selected].fillColor === Color.WhiteTransparent}
            onClick={() => {
              TextboxUIAction.setTextboxFillColor(selected, Color.WhiteTransparent, dispatch);
            }} />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle imgName="text_txtbox_line_color" />
        <ToolIconRadioButtonSet>
          <SelectableColorIconButton
            title="赤"
            imagePath="images/setting-popup/line-color/btn_line_color_red"
            active={toolSettings[selected].lineColor === Color.Red}
            onClick={() => {
              TextboxUIAction.setTextboxLineColor(selected, Color.Red, dispatch);
            }} />
          <SelectableColorIconButton
            title="青"
            imagePath="images/setting-popup/line-color/btn_line_color_blue"
            active={toolSettings[selected].lineColor === Color.Blue}
            onClick={() => {
              TextboxUIAction.setTextboxLineColor(selected, Color.Blue, dispatch);
            }} />
          <SelectableColorIconButton
            title="黄色"
            imagePath="images/setting-popup/line-color/btn_line_color_yellow"
            active={toolSettings[selected].lineColor === Color.Yellow}
            onClick={() => {
              TextboxUIAction.setTextboxLineColor(selected, Color.Yellow, dispatch);
            }} />
          <SelectableColorIconButton
            title="緑"
            imagePath="images/setting-popup/line-color/btn_line_color_green"
            active={toolSettings[selected].lineColor === Color.Green}
            onClick={() => {
              TextboxUIAction.setTextboxLineColor(selected, Color.Green, dispatch);
            }} />
          <SelectableColorIconButton
            title="黒"
            imagePath="images/setting-popup/line-color/btn_line_color_black"
            active={toolSettings[selected].lineColor === Color.Black}
            onClick={() => {
              TextboxUIAction.setTextboxLineColor(selected, Color.Black, dispatch);
            }} />
          <SelectableColorIconButton
            title="白"
            imagePath="images/setting-popup/line-color/btn_line_color_white"
            active={toolSettings[selected].lineColor === Color.White}
            onClick={() => {
              TextboxUIAction.setTextboxLineColor(selected, Color.White, dispatch);
            }} />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle imgName="text_txtbox_typeface" />
        <ToolIconRadioButtonSet style={{ justifyContent: 'center', width: '100%' }}>
          <SelectableRectangleIconButton
            title="明朝体"
            imagePath="images/setting-popup/typeface/btn_typeface_mincho"
            containerStyle={largeButtonContainerStyle}
            active={toolSettings[selected].fontType === FontType.Mincho}
            onClick={() => {
              TextboxUIAction.setTextboxFontType(selected, FontType.Mincho, dispatch);
            }} />
          <SelectableRectangleIconButton
            title="ゴシック体"
            imagePath="images/setting-popup/typeface/btn_typeface_gothic"
            containerStyle={largeButtonContainerStyle}
            active={toolSettings[selected].fontType === FontType.Gothic}
            onClick={() => {
              TextboxUIAction.setTextboxFontType(selected, FontType.Gothic, dispatch);
            }} />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle imgName="text_txtbox_font_size" />
        <TextboxFontSizeSlider textboxState={props} dispatch={dispatch} />
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle imgName="text_between_lines" />
        <TextboxLineHeightSlider textboxState={props} dispatch={dispatch} />
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle imgName="text_margin" />
        <TextboxPaddingSlider textboxState={props} dispatch={dispatch} />
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle imgName="text_txtbox_font_color" />
        <ToolIconRadioButtonSet>
          <SelectableColorIconButton
            title="赤"
            imagePath="images/setting-popup/color/btn_color_red_01"
            active={toolSettings[selected].textColor === Color.Red}
            onClick={() => {
              TextboxUIAction.setTextboxTextColor(selected, Color.Red, dispatch);
            }} />
          <SelectableColorIconButton
            title="青"
            imagePath="images/setting-popup/color/btn_color_blue_01"
            active={toolSettings[selected].textColor === Color.Blue}
            onClick={() => {
              TextboxUIAction.setTextboxTextColor(selected, Color.Blue, dispatch);
            }} />
          <SelectableColorIconButton
            title="黄色"
            imagePath="images/setting-popup/color/btn_color_yellow_01"
            active={toolSettings[selected].textColor === Color.Yellow}
            onClick={() => {
              TextboxUIAction.setTextboxTextColor(selected, Color.Yellow, dispatch);
            }} />
          <SelectableColorIconButton
            title="緑"
            imagePath="images/setting-popup/color/btn_color_green_01"
            active={toolSettings[selected].textColor === Color.Green}
            onClick={() => {
              TextboxUIAction.setTextboxTextColor(selected, Color.Green, dispatch);
            }} />
          <SelectableColorIconButton
            title="黒"
            imagePath="images/setting-popup/color/btn_color_black_01"
            active={toolSettings[selected].textColor === Color.Black}
            onClick={() => {
              TextboxUIAction.setTextboxTextColor(selected, Color.Black, dispatch);
            }} />
          <SelectableColorIconButton
            title="白"
            imagePath="images/setting-popup/color/btn_color_white_01"
            active={toolSettings[selected].textColor === Color.White}
            onClick={() => {
              TextboxUIAction.setTextboxTextColor(selected, Color.White, dispatch);
            }} />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle imgName="text_txtbox_balloon_type" />
        <ToolIconRadioButtonSet style={{ justifyContent: 'center', width: '100%' }} >
          <SelectableRectangleIconButton
            title="マスク"
            imagePath="images/setting-popup/textbox/btn_txtbox_balloon_type_01"
            containerStyle={largeButtonContainerStyle}
            active={toolSettings[selected].type === ShapeKind.Sticky}
            onClick={() => {
              TextboxUIAction.setTextboxType(selected, ShapeKind.Sticky, dispatch);
            }} />
          <SelectableRectangleIconButton
            title="吹き出し"
            imagePath="images/setting-popup/textbox/btn_txtbox_balloon_type_02"
            containerStyle={largeButtonContainerStyle}
            active={toolSettings[selected].type === ShapeKind.Balloon}
            onClick={() => {
              TextboxUIAction.setTextboxType(selected, ShapeKind.Balloon, dispatch);
            }} />
          <SelectableRectangleIconButton
            title="文字のみ"
            imagePath="images/setting-popup/textbox/btn_txtbox_balloon_type_03"
            containerStyle={largeButtonContainerStyle}
            active={toolSettings[selected].type === ShapeKind.None}
            onClick={() => {
              TextboxUIAction.setTextboxType(selected, ShapeKind.None, dispatch);
            }} />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>
    </SettingTabPanelList>
  );
});

const mapStateToProps = (appStates: AppStates) => ({ ...appStates.ui.textbox });

export default connect(mapStateToProps)(TextboxSettingPanel);
